// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class TradingSystem {
    constructor(msg) {
        this.accepted = true;
        this.logoBytes = msg.ImageBytes;
        this.login = msg.Login;
        this.name = msg.Name;
        this.companyName = msg.CompanyName;
        this.tradingSystemID = msg.ID;
        this.riskDisclosureText = msg.RiskDisclosure;
    }
}
